import { useState } from 'react'
import constate from 'constate'

const useUser = () => {
  const [user, setUser] = useState(null)

  return { user, setUser }
}

const [UserProvider, useUserContext] = constate(useUser)

export { UserProvider, useUserContext }
